import {Box, Container, CssBaseline} from '@mui/material';
import logo from "../../assets/logo.svg";
import React from "react";
import {useTheme} from "@mui/material/styles";

interface ContainerProps {
    children: React.ReactNode;
}

function LoginContainer({ children }: ContainerProps) {
    const theme = useTheme();
    return (
        <div style={{backgroundColor: '#f3f3f3', height: '100vh', paddingTop: '10%'}}>

            <Container component="main" maxWidth="xs" sx={{boxShadow: 5, borderRadius: '10%', backgroundColor: theme.palette.secondary.main, paddingBottom: '60px !important'}}>
                <CssBaseline/>
                <div style={{width: '100%', height: '140px', display: 'flex'}}>
                    <img style={{height: '160px', flex: 1}} src={logo}/>
                </div>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    {children}
                </Box>
            </Container>
        </div>
    );
}


export default LoginContainer;
